// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\home\\\\WelcomeSection\\\\WelcomeSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\home\\WelcomeSection\\WelcomeSection.tsx");
  import.meta.hot.lastModified = "1757171103323.9631";
}
// REMIX HMR END

import { HeroSection } from "./components/HeroSection";
import { HeroActions } from "./components/HeroActions";
const heroActions = [{
  label: "Apply for membership",
  href: "/apply",
  variant: "fill-white",
  icon: true
}, {
  label: "Explore services",
  href: "/services",
  variant: "outline-white"
}];
export function WelcomeSection() {
  return <HeroSection backgroundImage="/images/home/welcome.png" title="WHAT YOU NEED <br /> TO CREATE" subtitle={{
    mobile: "We empower creators to transform ideas into reality wherever they are",
    desktop: "Nomadic Studios empowers creators to transform ideas into reality wherever they are"
  }}>
      <HeroActions actions={heroActions} />
    </HeroSection>;
}
_c = WelcomeSection;
var _c;
$RefreshReg$(_c, "WelcomeSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;